import { createContext, ReactNode, useState } from 'react';
import type { ExperimentClient, Variants } from '@amplitude/experiment-js-client';

export type AmplitudeExperimentsContextType = {
    client?: ExperimentClient | undefined;
    deviceId: string | null;
    setVariants?: (variants: Variants) => void;
    userId: string | null;
    variants: Variants;
};

export type AmplitudeExperimentsContextProps = AmplitudeExperimentsContextType & {
    children: ReactNode;
};

export const AmplitudeExperimentsContext = createContext<AmplitudeExperimentsContextType>({
    client: null,
    deviceId: null,
    userId: null,
    variants: {},
});

export const AmplitudeExperimentsProvider = ({
    children,
    variants: variantsExternal,
    ...value
}: AmplitudeExperimentsContextProps) => {
    const [variants, setVariants] = useState<Variants>(variantsExternal);

    return (
        <AmplitudeExperimentsContext.Provider value={{ ...value, setVariants, variants }}>
            {children}
        </AmplitudeExperimentsContext.Provider>
    );
};
